import { Moment } from "moment";
import * as moment from "moment";
import { EstadoCivilEnum } from "./EstadoCivilEnum";
import { PropertyRegimeEnum } from "./PropertyRegimeEnum";
import { IAddressOwner } from "./IAddressOwner";
import { IBankOwner } from "./IBankOwner";
import { EnumEstadoCivil } from "src/services/types/EnumEstadoCivil";
import { TradeAccountTypeEnum } from "src/components/common/BankInfo/TradeAccountTypeEnum";
import ISpouse from '../../ISpouse';

export interface ITradeOwner {
  id: number;
  cpfCnpj?: string;
  login?: string;
  fullName?: string;
  phoneNumber?: string;
  birthDate?: Moment;
  nationality?: string;
  civilStatus?: EstadoCivilEnum | string;
  propertyRegime?: PropertyRegimeEnum | string;
  marriageDate?: Moment;
  profession?: string;
  rg?: string;
  rgState?: string;
  rgExpeditionDate?: Moment;
  rgIssuingAuthority?: string;
  address: IAddressOwner;
  mothersName?: string;
  fathersName?: string;
  bankData: IBankOwner;
  spouse?: ISpouse;
}

export function createEmptyTradeOwner() {
  return {
    id: 0,
    birthDate: moment(),
    civilStatus: EnumEstadoCivil.solteiro,
    cpfCnpj: "",
    fullName: "",
    login: "",
    mothersName: "",
    fathersName: "",
    nationality: "",
    phoneNumber: "",
    profession: "",
    propertyRegime: PropertyRegimeEnum.Indefinido,
    rg: "",
    rgState: "",
    rgIssuingAuthority: "",
    rgExpeditionDate: moment(),
    address: {
      zipcode: "",
      state: "",
      city: "",
      addressNumber: "",
      address: "",
      addressComplement: "",
      neighborhood: ""
    },
    bankData: {
      account: "",
      accountDigit: "",
      accountType: TradeAccountTypeEnum.Corrente,
      agency: "",
      bank: ""
    }
  } as ITradeOwner;
}



// WEBPACK FOOTER //
// ./src/services/interfaces/trade/tradeOwner/ITradeOwner.ts